import { useState } from "react";
import { ValueLabelOption, createValueLabelOption } from "../../types/commonTypes";
import { PRIVACY_LABEL, LINEAR_PRIVACY_LABEL } from "../common-cmp";
import PrivacyCheckCmp from "../../components/privacy/PrivacyCheckCmp";

export const usePrivacyCheckCmp = (initialValue: boolean, companyName?: string) => {
    let privacy = PRIVACY_LABEL
    if (companyName === "LINEAR") {
        privacy = LINEAR_PRIVACY_LABEL
    }
    const [privacyChecked, setPrivacyChecked] = useState<ValueLabelOption<boolean>>(createValueLabelOption(initialValue, privacy))

    const privacyCmp = <PrivacyCheckCmp
        companyName={companyName}
        privacyChecked={privacyChecked}
        setPrivacyChecked={setPrivacyChecked} />

    return {
        privChecked: privacyChecked,
        PrivCheckedCmp: privacyCmp
    }
}